<template>
    <div class="wrapper-content">
        <slot />
    </div>
</template>

<style scoped lang="scss">
@import '../../assets/styles/_main.scss';

.wrapper-content {
    box-shadow: 0 16px 32px -12px rgba($text-high-emphasis, 0.1);
    min-width: 230px;
    border-radius: 12px;
    border: 1px solid $border;
    background: $card-background;
    padding: 8px;
}

body[theme='dark'] .wrapper-content {
    background-color: $card-neutral-background;
}
</style>
